
import Vue from 'vue'
import Location from './location'
import LocationsMap from './locationsMap.vue'
import LocationLabel from './locationLabel.vue'

//let locations: Location[] = [
//    {
//        title: 'Admin office', address: '1312 38th Street', city: 'Brooklyn', state: 'NY',zip: '11218', lng: -73.985439, lat: 40.641022
//    },
//    {
//        title: 'YvY ECC - Boro Park', address: '1257 38th Street', city: 'Brooklyn', state: 'NY',zip: '11218', lng: -73.986652, lat: 40.641756
//    },
//    {
//        title: 'YvY ECC - Williamsburg', address: '722 Myrtle Ave', city: 'Brooklyn', state: 'NY',zip: '11218', lng: -73.954307, lat: 40.694791
//    },
//    {
//        title: 'YvY ECC - Crown Heights', address: '275 Kingston Avenue', city: 'Brooklyn', state: 'NY',zip: '11218', lng: -73.942106, lat: 40.670342
//    }
//]


export default Vue.extend({
    components: {
        LocationsMap,LocationLabel
    },
    props: {
        locations: Array as () => Array<Location>
    },
    data() {
        return {
          //  locations,
            selectedLocation: null
        }
    },
    methods: {
        locationSelected: function (loc) {
            if (this.selectedLocation == loc) {
                this.selectedLocation = null;
            } else {
                this.selectedLocation = loc;
            }

            this.$forceUpdate();
        }
    }
   
})
